import { createSelector } from '@reduxjs/toolkit';
import { selectLastAppliedFilter } from '../searchMetaTooltip';
import { selectSearchMetaRefreshing } from './selectSearchMetaRefreshing';

export const selectIsGeoMetaRefreshing = createSelector(
  [selectLastAppliedFilter, selectSearchMetaRefreshing],
  (lastAppliedFilter, searchMetaRefreshing) => lastAppliedFilter === 'geo' && searchMetaRefreshing,
);
